import React from "react";
import "../CSS/Services.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLeaf } from "@fortawesome/free-solid-svg-icons";

const Services=()=>{
    return(
        <section className="ftco-section ftco-servicesection">
        {/* <div className="blob">
    <svg
      id="10015.io"
      viewBox="0 0 480 480"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#edb9cd", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#f4f6f6", stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <path
        fill="url(#gradient1)"
        d="M439,274Q403,308,402,354.5Q401,401,356,406.5Q311,412,275.5,428.5Q240,445,212.5,409Q185,373,162.5,356.5Q140,340,118.5,319.5Q97,299,53,269.5Q9,240,80,221.5Q151,203,117.5,143.5Q84,84,119,57.5Q154,31,197,43Q240,55,265.5,85.5Q291,116,301,142.5Q311,169,335,180Q359,191,417,215.5Q475,240,439,274Z"
      />
    </svg>
  </div>
    <div className="blob1">
      <svg
      id="10015.io"
      viewBox="0 0 480 480"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
     <defs>
        <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#edb9cd", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#f4f6f6", stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <path
        fill="url(#gradient1)"
        d="M408,277Q380,314,352.5,338.5Q325,363,293,389.5Q261,416,220,408.5Q179,401,142.5,380Q106,359,65.5,326Q25,293,59.5,248.5Q94,204,104.5,166.5Q115,129,141.5,89Q168,49,216,43.5Q264,38,298,72.5Q332,107,341.5,144.5Q351,182,393.5,211Q436,240,408,277Z"
      />
    </svg>

    </div> */}
        <div className="servianicon">
          <div className="row servicecardhm">
            <div className="ftco-animate servicecards">
            
              <div className="media d-block text-center block-6 services">
                <div className="icon d-flex mb-3">
                  <span className="flaticon-facial-treatment" />
                </div>
                <div className="media-body">
                  <h3 className="heading blackthemegradient">Skin &amp; Beauty Care</h3>
                  <p style={{textAlign:"justify", color:"white"}}>
                  Enhance your natural glow with our expert Skin & Beauty Care services, tailored to nourish and rejuvenate your skin.
                  </p>
                </div>
              </div>
              </div>
          
            <div className="ftco-animate servicecards">
              <div className="media d-block text-center block-6 services">
                <div className="icon d-flex mb-3">
                  <span className="flaticon-cosmetics" />
                </div>
                <div className="media-body">
                  <h3 className="heading blackthemegradient">Makeup Pro</h3>
                  <p style={{textAlign:"justify",color:"white"}}>
                  Unleash your best look with our Makeup Pro services, perfect for every occasion with flawless, professional results.
                  </p>
                </div>
              </div>
            </div>
            <div className="ftco-animate servicecards">
              <div className="media d-block text-center block-6 services">
                <div className="icon d-flex mb-3">
                  <span className="flaticon-curl" />
                </div>
                <div className="media-body">
                  <h3 className="heading blackthemegradient">Hair Style</h3>
                  <p style={{textAlign:"justify",color:"white"}}>
                  Achieve the perfect look with our expert Hair Styling services, tailored to match your unique style and personality.
                  </p>
                </div>
              </div>
            </div>
            <div className="ftco-animate servicecards">
              <div className="media d-block text-center block-6 services">
                <div className="icon d-flex mb-3">
                <span className="flaticon-flower" />
                </div>
                <div className="media-body">
                  <h3 className="heading blackthemegradient">Aesthetic</h3>
                  <p style={{textAlign:"justify", color:"white"}}>
                  Unwind with our premium treatments, featuring carefully curated products that nourish and rejuvenate.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
}

export default Services;